
<script>

  import { createEventDispatcher, onMount } from 'svelte';

  const dispatch = createEventDispatcher();

  export let item;
  export let playing = false;

  let url_blob;
  let durationSeconds;
  let title;
  let playback_timeout;
  let id;

  let src;

  $: if (item) {
    ({
      url_blob,
      durationSeconds = 10,
      title,
      id
    } = item);

    if (url_blob != src) {
      src = url_blob;
      dispatch('media.ready');
    }
  }

  onMount(() => {
    if (src) {
      dispatch('media.ready');
    }
    return () => clearTimeout(playback_timeout);
  });

  $: {
    if (playing) play();
    else stop();
  }

  export function play () {
    const duration_ms = durationSeconds * 1000;
    playback_timeout = setTimeout(() => dispatch('media.finished'), duration_ms);
  }

  export function stop () {
    clearTimeout(playback_timeout);
  }

</script>

{#if src}
  <img {src} alt={title} data-id={id} >
{/if}

<style>
  img {
    width: inherit;
    height: inherit;
    object-fit: contain;
    object-position: center;
  }
</style>
